import { isFieldFilterable } from './FilterConfiguration'

export default function AddFilter({selectFilterKey, openOrgPicker}) {
    const filters = useSel(s => s.local.filters ?? null);
    const dashboardFields = useSel(s => s.dashboard.dashboardFields ?? []);
    const questions = useSel(s => s.dashboard.survey.questions);

    const availableFieldFilters = dashboardFields.filter(f => {
        if (!isFieldFilterable(f, questions)) return false;
        const filterKey = 'field_' + f.id;
        return filters[filterKey] === undefined || filters[filterKey] === null;
    }).map(field => <a
        key={field.id}
        href="#"
        className="add-filter-option"
        onClick={() => selectFilterKey('field_' + field.id)}>
            {field.name}
        </a>
    );

    const orgFilterAvailable = filters['organisation_id'] === undefined || filters['organisation_id'] === null;

    return <div className="add-filters">
        {orgFilterAvailable && <a
            href="#"
            className="add-filter-option"
            onClick={(e) => { e.preventDefault(); openOrgPicker(); }}>
                Organisation
            </a>}
        {availableFieldFilters.length > 0 && orgFilterAvailable && <div className="add-filter-option-divider"></div>}
        {availableFieldFilters}
    </div>
}
